import store from '../../store';
import appConfig from '../../app.config';
import { OutageWaningInfo } from './outage-events';

export default {
  name: 'outageHelper',
  getOutageStartDateTime() {
    return store.getters.outageSetting ? new Date(store.getters.outageSetting.fromDateTime) : null;
  },
  getOutageEndDateTime() {
    return store.getters.outageSetting ? new Date(store.getters.outageSetting.endDateTime) : null;
  },
  getLastOutageCheckedTime() {
    return store.getters.outageLastCheckedOn ? new Date(store.getters.outageLastCheckedOn) : null;
  },
  getBackdoorCodeUsedTime() {
    return store.getters.backdoorCodeUsedOn ? new Date(store.getters.backdoorCodeUsedOn) : null;
  },
  isInOutage() {
    const oStartDt = this.getOutageStartDateTime();
    const oEndDt = this.getOutageEndDateTime();

    if (oStartDt && oEndDt) {
      const now = Date.now();
      const oStartTime = oStartDt.setMinutes(
        oStartDt.getMinutes() - 1, // if less than 1 min remaining kick the user out, o
        // therwise next (tick)check will be during the outage
      );
      const oEndTime = oEndDt.getTime();
      if (oStartTime <= now && now < oEndTime) { return true; }
    }
    return false;
  },
  getOutageWarningInfo() {
    const outageWarning = new OutageWaningInfo(false, -1);
    const oStartDt = this.getOutageStartDateTime();
    if (oStartDt) {
      const now = Date.now();
      const oStartTime = oStartDt.getTime();
      const warningStartsTime = oStartDt.setMinutes(
        oStartDt.getMinutes() - appConfig.outageWarningStartsIn - 1,
      );
      if (warningStartsTime <= now && now < oStartTime) {
        outageWarning.remainingTime = Math.floor((oStartTime - now) / (1000 * 60));
        outageWarning.show = true;
      }
    }
    return outageWarning;
  },
  isOutageConfirmed() { // 2 minute before displaying the warning starts
    const oStartDate = this.getOutageStartDateTime();
    const oEndDt = this.getOutageEndDateTime();
    if (oStartDate && oEndDt) {
      const lastCheckedTime = this.getLastOutageCheckedTime();
      const confirmOutageAfter = this.getOutageStartDateTime().setMinutes(
        oStartDate.getMinutes() - (appConfig.outageWarningStartsIn + 2),
      );
      const now = Date.now();
      const isEligibleForConfirm = (confirmOutageAfter <= now && now < oEndDt.getTime());
      if (isEligibleForConfirm) {
        if (lastCheckedTime < confirmOutageAfter) {
          return false;
        }
      }
    }
    return true;
  },
  isOutageRequestTime() { // check for updates on outage every 4 hours
    const lastCheckedTime = this.getLastOutageCheckedTime();
    if (!lastCheckedTime) { return true; }

    const now = Date.now();
    const outageDataExpiresOn = lastCheckedTime.setMinutes(
      lastCheckedTime.getMinutes + 240, // 4 hours
    );
    if (now > outageDataExpiresOn) { return true; }

    return false;
  },

  isUserAllowedForBackdoor() {
    const { loggedUser } = store.getters;
    return (loggedUser && loggedUser.roles ? loggedUser.roles.some((r) => r.roleName === 'SuperAdmin') : false);
  },
  isBackdoorCodeUsageValidForTheCurrentSession() {
    const codeUsedDt = this.getBackdoorCodeUsedTime();
    if (codeUsedDt) {
      const oStartDt = this.getOutageStartDateTime();
      const oEndDt = this.getOutageEndDateTime();
      if (oStartDt && oEndDt) {
        const codeUsedTime = codeUsedDt.getTime();
        const oStartTime = oStartDt.getTime();
        const oEndTime = oEndDt.getTime();
        if (oStartTime <= codeUsedTime && codeUsedTime < oEndTime) { return true; }
      }
    }
    return false;
  },
};
